import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return null;
  }

  if (profile.createdAt) {
    return profile.createdAt;
  } else {
    return null;
  }
};
//VERIFY IF THE JWT IS SET
const getMyProfileCreatedOn = createSelector(getData, createdAt => createdAt);
export default getMyProfileCreatedOn;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyProfileCreatedOn.js